export default "__VITE_ASSET__DRJT6f3C__"